const initialState = {
  isLoading: false,
  passwordobj: {},
  errors: null,
};

const changePasswordreducer = (state = initialState, action) => {
  switch (action.type) {
    case "change_password_req":
      return {
        ...state,
        isLoading: true,
      };
    case "change_password_success":
      return {
        ...state,
        isLoading: false,

        passwordobj: action.payload,
      };
    case "change_password_failure":
      return {
        ...state,
        isLoading: false,

        errors: action.payload,
      };

    default:
      return state;
  }
};

export { changePasswordreducer };
